const Cart = () => {
  // const body = document.body;
  const cartOpener = document.querySelector(".cart-modal__opener");
  const cart = document.querySelector(".cart-modal");
  const cartProducts = [...document.querySelectorAll(".cart-modal__products-item")];
  const editLocationOpener = document.querySelector(".cart-modal__footer-change-country");
  const editLocationModalWrapper = document.querySelector(".cart-modal__footer-edit-location-wrapper");
  const editProductModal = document.querySelector(".cart-modal__edit-product");

  // Edit product modal
  if (cartProducts.length > 0) {
    cartProducts.forEach((cartProduct) => {
      const editProductModalOpeners = [...cartProduct.querySelectorAll(".edit-product-btn")];

      if (editProductModalOpeners.length > 0) {
        editProductModalOpeners.forEach((editProductModalOpener) => {
          editProductModalOpener.addEventListener("click", () => {
            editProductModal.classList.add("opened");
          });
        })
      }

      if (editProductModal) {
        const closer = editProductModal.querySelector(".cart-modal__edit-product-closer");
        if(closer){
          closer.addEventListener("click", () => {
            editProductModal.classList.remove("opened");
          })
        }
      }
    });
  }

  // Edit location modal
  if (editLocationOpener) {
    editLocationOpener.addEventListener("click", () => {
      editLocationModalWrapper.classList.add("opened");
    })
  }

  if (editLocationModalWrapper) {
    const closers = [...editLocationModalWrapper.querySelectorAll(".cart-modal__footer-edit-location-closer")];
    const modal = editLocationModalWrapper.querySelector(".cart-modal__footer-edit-location-modal");

    if (closers.length > 0) {
      closers.forEach((closer) => {
        closer.addEventListener("click", () => {
          editLocationModalWrapper.classList.remove("opened");
        });
      })
    };

    document.addEventListener("click", (event) => {
      if (!modal.contains(event.target) && !editLocationOpener.contains(event.target) && editLocationModalWrapper.classList.contains("opened")) {
        editLocationModalWrapper.classList.remove("opened");
      }
    })
  }

  // Cart modal
  const handleClickOutside = (event) => {
    const hasCards = [...cart.querySelectorAll('.cart-modal__products-item')].length > 0;
    if (!hasCards && !cart.contains(event.target) && !cartOpener.contains(event.target) && cart.classList.contains("opened")) {
      cart.classList.remove("opened");
    }
  };
  
  if (cartOpener && cart) {
    const cartOverlay = cart.querySelector(".cart-modal__overlay");
    const cartCloser = cart.querySelector(".cart-modal__closer");

    cartOpener.addEventListener("click", () => {
      cart.classList.add("opened");
      // body.classList.add("no-scroll");
    });

    cartCloser.addEventListener("click", () => {
      cart.classList.remove("opened");
      // body.classList.remove("no-scroll");
    });

    if (cartOverlay) {
      cartOverlay.addEventListener("click", () => {
        cart.classList.remove("opened");
        // body.classList.remove("no-scroll");
      });
    }

    document.addEventListener("click", handleClickOutside);
  }


}

export default Cart;